import React from "react";
import styles from "./style.module.scss";
import logo from "../../../../assets/images/mashie-shield-with-text-white.png";
import DeprecatedBanner from "./utils/DeprecatedBanner";
import APIVersionDropdown from "./utils/APIVersionDropdown";
import SectionDropdown from "./utils/SectionDropdown";
import EndpointsList from "./utils/EndpointsList";
import Endpoints from "./utils/Endpoints";
import GETTeeTimes from "./teetimes/GETTeeTimes.json";
import GETTeeTimesId from "./teetimes/GETTeeTimesId.json";
import GETTeeTimesIdMessages from "./teetimes/GETTeeTimesIdMessages.json";
import POSTTeeTimes from "./teetimes/POSTTeeTimes.json";
import PUTTeeTimesId from "./teetimes/PUTTeeTimesId.json";
import POSTTeeTimesIdMessages from "./teetimes/POSTTeeTimesIdMessages.json";

const specs = [
    GETTeeTimes,
    POSTTeeTimes,
    GETTeeTimesId,
    PUTTeeTimesId,
    GETTeeTimesIdMessages,
    POSTTeeTimesIdMessages,
];

export default function Index() {
    return (
        <div className='app events' style={{ paddingBottom: "100px" }}>
            <div className={styles.fullHeader} alt='event'>
                <img className={styles.entityLogo} src={logo} alt='logo' />
                <h1 className={styles.headerText}>
                    Tee Times Documentation (v2)
                </h1>
            </div>
            <div className='container'>
                <APIVersionDropdown version='v2' />
                <SectionDropdown page='teetimes' />
                <div className='row'>
                    <div className='col-12'>
                        <h2>About this API</h2>
                        <p>
                            This API allows you to see tee time bookings, see
                            tee time booking messages, create tee times, update
                            tee times and send tee time messages for a specific
                            member.
                        </p>
                        <div className={styles.spacer} />

                        <h2>Major updates since v1</h2>
                        <p>
                            <strong>FUNCTIONALITY CHANGE</strong> - Tee time
                            pricing now works on hour-by hour pricing for each
                            day of the week, for each month of the year.
                        </p>
                        <br />
                        <p>
                            <strong>FUNCTIONALITY CHANGE</strong> - Unconfirmed
                            booking timeslots are now displayed as "HH:00 -
                            HH:59" instead of "HH:00 - HH:00". Confirmed booking
                            timeslots are still "HH:MM"
                        </p>
                        <br />
                        <p>
                            <strong>DATA CHANGE</strong> - Some unnecessary _id
                            values have been removed where they cannot be used
                            for any lookup purposes. Please use self-generated
                            internal ID's for these should you currently rely on
                            them.
                        </p>
                    </div>
                    <div className='col-12'>
                        <div className={styles.spacer} />
                        <h2>Endpoints</h2>
                        <EndpointsList specs={specs} />
                        <div className={styles.spacer} />
                        <Endpoints specs={specs} />
                    </div>
                </div>
            </div>
            <DeprecatedBanner version='v2' />
        </div>
    );
}
